

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

const _reactAddonsShallowCompare = _interopRequireDefault(require('react-addons-shallow-compare'));

const _react = _interopRequireDefault(require('react'));

const _propTypes = _interopRequireDefault(require('prop-types'));

const _reactMomentProptypes = _interopRequireDefault(require('react-moment-proptypes'));

const _airbnbPropTypes = require('airbnb-prop-types');

const _moment = _interopRequireDefault(require('moment'));

const _object = _interopRequireDefault(require('object.values'));

const _isTouchDevice = _interopRequireDefault(require('is-touch-device'));

const _defaultPhrases = require('../defaultPhrases');

const _getPhrasePropTypes = _interopRequireDefault(require('../utils/getPhrasePropTypes'));

const _isInclusivelyAfterDay = _interopRequireDefault(require('../utils/isInclusivelyAfterDay'));

const _isNextDay = _interopRequireDefault(require('../utils/isNextDay'));

const _isSameDay = _interopRequireDefault(require('../utils/isSameDay'));

const _isAfterDay = _interopRequireDefault(require('../utils/isAfterDay'));

const _isBeforeDay = _interopRequireDefault(require('../utils/isBeforeDay'));

const _getVisibleDays = _interopRequireDefault(require('../utils/getVisibleDays'));

const _isDayVisible = _interopRequireDefault(require('../utils/isDayVisible'));

const _getSelectedDateOffset = _interopRequireDefault(require('../utils/getSelectedDateOffset'));

const _toISODateString = _interopRequireDefault(require('../utils/toISODateString'));

const _toISOMonthString = _interopRequireDefault(require('../utils/toISOMonthString'));

const _DisabledShape = _interopRequireDefault(require('../shapes/DisabledShape'));

const _FocusedInputShape = _interopRequireDefault(require('../shapes/FocusedInputShape'));

const _ScrollableOrientationShape = _interopRequireDefault(require('../shapes/ScrollableOrientationShape'));

const _DayOfWeekShape = _interopRequireDefault(require('../shapes/DayOfWeekShape'));

const _CalendarInfoPositionShape = _interopRequireDefault(require('../shapes/CalendarInfoPositionShape'));

const _constants = require('../constants');

const _DayPicker = _interopRequireDefault(require('./DayPicker'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError('Invalid attempt to destructure non-iterable instance'); }

function _iterableToArrayLimit(arr, i) { const _arr = []; let _n = true; let _d = false; let _e; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i.return != null) _i.return(); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (let i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; let ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(sym => Object.getOwnPropertyDescriptor(source, sym).enumerable)); } ownKeys.forEach((key) => { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value, enumerable: true, configurable: true, writable: true,
    });
  } else { obj[key] = value; } return obj;
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === 'object' || typeof call === 'function')) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : (function () { function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); } return _getPrototypeOf; }()); return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (let i = 0; i < props.length; i++) { const descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function'); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || (function () { function _setPrototypeOf(o, p) { o.__proto__ = p; return o; } return _setPrototypeOf; }()); return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

const propTypes = process.env.NODE_ENV !== 'production' ? (0, _airbnbPropTypes.forbidExtraProps)({
  startDate: _reactMomentProptypes.default.momentObj,
  endDate: _reactMomentProptypes.default.momentObj,
  onDatesChange: _propTypes.default.func,
  startDateOffset: _propTypes.default.func,
  endDateOffset: _propTypes.default.func,
  minDate: _reactMomentProptypes.default.momentObj,
  maxDate: _reactMomentProptypes.default.momentObj,
  focusedInput: _FocusedInputShape.default,
  onFocusChange: _propTypes.default.func,
  onClose: _propTypes.default.func,
  keepOpenOnDateSelect: _propTypes.default.bool,
  minimumNights: _propTypes.default.number,
  disabled: _DisabledShape.default,
  isOutsideRange: _propTypes.default.func,
  isDayBlocked: _propTypes.default.func,
  isDayHighlighted: _propTypes.default.func,
  getMinNightsForHoverDate: _propTypes.default.func,
  // DayPicker props
  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes.default.func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes.default.func, 'renderMonthText', 'renderMonthElement'),
  enableOutsideDays: _propTypes.default.bool,
  numberOfMonths: _propTypes.default.number,
  orientation: _ScrollableOrientationShape.default,
  withPortal: _propTypes.default.bool,
  initialVisibleMonth: _propTypes.default.func,
  hideKeyboardShortcutsPanel: _propTypes.default.bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes.default.bool,
  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
  navPrev: _propTypes.default.node,
  navNext: _propTypes.default.node,
  noNavButtons: _propTypes.default.bool,
  onPrevMonthClick: _propTypes.default.func,
  onNextMonthClick: _propTypes.default.func,
  onOutsideClick: _propTypes.default.func,
  renderCalendarDay: _propTypes.default.func,
  renderDayContents: _propTypes.default.func,
  renderCalendarInfo: _propTypes.default.func,
  renderKeyboardShortcutsButton: _propTypes.default.func,
  calendarInfoPosition: _CalendarInfoPositionShape.default,
  firstDayOfWeek: _DayOfWeekShape.default,
  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
  // accessibility
  onBlur: _propTypes.default.func,
  isFocused: _propTypes.default.bool,
  showKeyboardShortcuts: _propTypes.default.bool,
  onTab: _propTypes.default.func,
  onShiftTab: _propTypes.default.func,
  // i18n
  monthFormat: _propTypes.default.string,
  weekDayFormat: _propTypes.default.string,
  phrases: _propTypes.default.shape((0, _getPhrasePropTypes.default)(_defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes.default.string,
  isRTL: _propTypes.default.bool,
}) : {};
const defaultProps = {
  startDate: undefined,
  // TODO: use null
  endDate: undefined,
  // TODO: use null
  minDate: null,
  maxDate: null,
  onDatesChange: (function () {
    function onDatesChange() {}

    return onDatesChange;
  }()),
  startDateOffset: undefined,
  endDateOffset: undefined,
  focusedInput: null,
  onFocusChange: (function () {
    function onFocusChange() {}

    return onFocusChange;
  }()),
  onClose: (function () {
    function onClose() {}

    return onClose;
  }()),
  keepOpenOnDateSelect: false,
  minimumNights: 1,
  disabled: false,
  isOutsideRange: (function () {
    function isOutsideRange() {}

    return isOutsideRange;
  }()),
  isDayBlocked: (function () {
    function isDayBlocked() {}

    return isDayBlocked;
  }()),
  isDayHighlighted: (function () {
    function isDayHighlighted() {}

    return isDayHighlighted;
  }()),
  getMinNightsForHoverDate: (function () {
    function getMinNightsForHoverDate() {}

    return getMinNightsForHoverDate;
  }()),
  // DayPicker props
  renderMonthText: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  daySize: _constants.DAY_SIZE,
  navPrev: null,
  navNext: null,
  noNavButtons: false,
  onPrevMonthClick: (function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }()),
  onNextMonthClick: (function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }()),
  onOutsideClick: (function () {
    function onOutsideClick() {}

    return onOutsideClick;
  }()),
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderCalendarInfo: null,
  renderMonthElement: null,
  renderKeyboardShortcutsButton: undefined,
  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
  firstDayOfWeek: null,
  verticalHeight: null,
  noBorder: false,
  transitionDuration: undefined,
  verticalBorderSpacing: undefined,
  horizontalMonthPadding: 13,
  // accessibility
  onBlur: (function () {
    function onBlur() {}

    return onBlur;
  }()),
  isFocused: false,
  showKeyboardShortcuts: false,
  onTab: (function () {
    function onTab() {}

    return onTab;
  }()),
  onShiftTab: (function () {
    function onShiftTab() {}

    return onShiftTab;
  }()),
  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined,
  isRTL: false,
};

const getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
  if (focusedInput === _constants.START_DATE) {
    return phrases.chooseAvailableStartDate;
  }

  if (focusedInput === _constants.END_DATE) {
    return phrases.chooseAvailableEndDate;
  }

  return phrases.chooseAvailableDate;
};

const DayPickerRangeController =
/* #__PURE__ */
(function (_ref) {
  _inherits(DayPickerRangeController, _ref);

  _createClass(DayPickerRangeController, [{
    key: !_react.default.PureComponent && 'shouldComponentUpdate',
    value: (function () {
      function value(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare.default)(this, nextProps, nextState);
      }

      return value;
    }()),
  }]);

  function DayPickerRangeController(props) {
    let _this;

    _classCallCheck(this, DayPickerRangeController);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayPickerRangeController).call(this, props));
    _this.isTouchDevice = (0, _isTouchDevice.default)();
    _this.today = (0, _moment.default)();
    _this.modifiers = {
      today: (function () {
        function today(day) {
          return _this.isToday(day);
        }

        return today;
      }()),
      blocked: (function () {
        function blocked(day) {
          return _this.isBlocked(day);
        }

        return blocked;
      }()),
      'blocked-calendar': (function () {
        function blockedCalendar(day) {
          return props.isDayBlocked(day);
        }

        return blockedCalendar;
      }()),
      'blocked-out-of-range': (function () {
        function blockedOutOfRange(day) {
          return props.isOutsideRange(day);
        }

        return blockedOutOfRange;
      }()),
      'highlighted-calendar': (function () {
        function highlightedCalendar(day) {
          return props.isDayHighlighted(day);
        }

        return highlightedCalendar;
      }()),
      valid: (function () {
        function valid(day) {
          return !_this.isBlocked(day);
        }

        return valid;
      }()),
      'selected-start': (function () {
        function selectedStart(day) {
          return _this.isStartDate(day);
        }

        return selectedStart;
      }()),
      'selected-end': (function () {
        function selectedEnd(day) {
          return _this.isEndDate(day);
        }

        return selectedEnd;
      }()),
      'blocked-minimum-nights': (function () {
        function blockedMinimumNights(day) {
          return _this.doesNotMeetMinimumNights(day);
        }

        return blockedMinimumNights;
      }()),
      'selected-span': (function () {
        function selectedSpan(day) {
          return _this.isInSelectedSpan(day);
        }

        return selectedSpan;
      }()),
      'last-in-range': (function () {
        function lastInRange(day) {
          return _this.isLastInRange(day);
        }

        return lastInRange;
      }()),
      hovered: (function () {
        function hovered(day) {
          return _this.isHovered(day);
        }

        return hovered;
      }()),
      'hovered-span': (function () {
        function hoveredSpan(day) {
          return _this.isInHoveredSpan(day);
        }

        return hoveredSpan;
      }()),
      'hovered-offset': (function () {
        function hoveredOffset(day) {
          return _this.isInHoveredSpan(day);
        }

        return hoveredOffset;
      }()),
      'after-hovered-start': (function () {
        function afterHoveredStart(day) {
          return _this.isDayAfterHoveredStartDate(day);
        }

        return afterHoveredStart;
      }()),
      'first-day-of-week': (function () {
        function firstDayOfWeek(day) {
          return _this.isFirstDayOfWeek(day);
        }

        return firstDayOfWeek;
      }()),
      'last-day-of-week': (function () {
        function lastDayOfWeek(day) {
          return _this.isLastDayOfWeek(day);
        }

        return lastDayOfWeek;
      }()),
      'hovered-start-first-possible-end': (function () {
        function hoveredStartFirstPossibleEnd(day, hoverDate) {
          return _this.isFirstPossibleEndDateForHoveredStartDate(day, hoverDate);
        }

        return hoveredStartFirstPossibleEnd;
      }()),
      'hovered-start-blocked-minimum-nights': (function () {
        function hoveredStartBlockedMinimumNights(day, hoverDate) {
          return _this.doesNotMeetMinNightsForHoveredStartDate(day, hoverDate);
        }

        return hoveredStartBlockedMinimumNights;
      }()),
    };

    const _this$getStateForNewM = _this.getStateForNewMonth(props);
    const { currentMonth } = _this$getStateForNewM;
    const { visibleDays } = _this$getStateForNewM; // initialize phrases
    // set the appropriate CalendarDay phrase based on focusedInput


    const chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
    _this.state = {
      hoverDate: null,
      currentMonth,
      phrases: _objectSpread({}, props.phrases, {
        chooseAvailableDate,
      }),
      visibleDays,
      disablePrev: _this.shouldDisableMonthNavigation(props.minDate, currentMonth),
      disableNext: _this.shouldDisableMonthNavigation(props.maxDate, currentMonth),
    };
    _this.onDayClick = _this.onDayClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onNextMonthClick = _this.onNextMonthClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onMonthChange = _this.onMonthChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onYearChange = _this.onYearChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onMultiplyScrollableMonths = _this.onMultiplyScrollableMonths.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(DayPickerRangeController, [{
    key: 'componentWillReceiveProps',
    value: (function () {
      function componentWillReceiveProps(nextProps) {
        const _this2 = this;

        const { startDate } = nextProps;
        const { endDate } = nextProps;
        const { focusedInput } = nextProps;
        const { getMinNightsForHoverDate } = nextProps;
        const { minimumNights } = nextProps;
        const { isOutsideRange } = nextProps;
        const { isDayBlocked } = nextProps;
        const { isDayHighlighted } = nextProps;
        const { phrases } = nextProps;
        const { initialVisibleMonth } = nextProps;
        const { numberOfMonths } = nextProps;
        const { enableOutsideDays } = nextProps;
        const _this$props = this.props;
        const prevStartDate = _this$props.startDate;
        const prevEndDate = _this$props.endDate;
        const prevFocusedInput = _this$props.focusedInput;
        const prevMinimumNights = _this$props.minimumNights;
        const prevIsOutsideRange = _this$props.isOutsideRange;
        const prevIsDayBlocked = _this$props.isDayBlocked;
        const prevIsDayHighlighted = _this$props.isDayHighlighted;
        const prevPhrases = _this$props.phrases;
        const prevInitialVisibleMonth = _this$props.initialVisibleMonth;
        const prevNumberOfMonths = _this$props.numberOfMonths;
        const prevEnableOutsideDays = _this$props.enableOutsideDays;
        const { hoverDate } = this.state;
        let { visibleDays } = this.state;
        let recomputeOutsideRange = false;
        let recomputeDayBlocked = false;
        let recomputeDayHighlighted = false;

        if (isOutsideRange !== prevIsOutsideRange) {
          this.modifiers['blocked-out-of-range'] = function (day) {
            return isOutsideRange(day);
          };

          recomputeOutsideRange = true;
        }

        if (isDayBlocked !== prevIsDayBlocked) {
          this.modifiers['blocked-calendar'] = function (day) {
            return isDayBlocked(day);
          };

          recomputeDayBlocked = true;
        }

        if (isDayHighlighted !== prevIsDayHighlighted) {
          this.modifiers['highlighted-calendar'] = function (day) {
            return isDayHighlighted(day);
          };

          recomputeDayHighlighted = true;
        }

        const recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
        const didStartDateChange = startDate !== prevStartDate;
        const didEndDateChange = endDate !== prevEndDate;
        const didFocusChange = focusedInput !== prevFocusedInput;

        if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocusedInput && didFocusChange) {
          const newMonthState = this.getStateForNewMonth(nextProps);
          const { currentMonth } = newMonthState;
          visibleDays = newMonthState.visibleDays;
          this.setState({
            currentMonth,
            visibleDays,
          });
        }

        let modifiers = {};

        if (didStartDateChange) {
          modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start');
          modifiers = this.addModifier(modifiers, startDate, 'selected-start');

          if (prevStartDate) {
            const startSpan = prevStartDate.clone().add(1, 'day');
            const endSpan = prevStartDate.clone().add(prevMinimumNights + 1, 'days');
            modifiers = this.deleteModifierFromRange(modifiers, startSpan, endSpan, 'after-hovered-start');
          }
        }

        if (didEndDateChange) {
          modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end');
          modifiers = this.addModifier(modifiers, endDate, 'selected-end');
        }

        if (didStartDateChange || didEndDateChange) {
          if (prevStartDate && prevEndDate) {
            modifiers = this.deleteModifierFromRange(modifiers, prevStartDate, prevEndDate.clone().add(1, 'day'), 'selected-span');
          }

          if (startDate && endDate) {
            modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
            modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
          }
        }

        if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
          const _startSpan = startDate.clone().add(1, 'day');

          const _endSpan = startDate.clone().add(minimumNights + 1, 'days');

          modifiers = this.addModifierToRange(modifiers, _startSpan, _endSpan, 'after-hovered-start');
        }

        if (prevMinimumNights > 0) {
          if (didFocusChange || didStartDateChange || minimumNights !== prevMinimumNights) {
            const _startSpan2 = prevStartDate || this.today;

            modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked-minimum-nights');
            modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked');
          }
        }

        if (didFocusChange || recomputePropModifiers) {
          (0, _object.default)(visibleDays).forEach((days) => {
            Object.keys(days).forEach((day) => {
              const momentObj = (0, _moment.default)(day);
              let isBlocked = false;

              if (didFocusChange || recomputeOutsideRange) {
                if (isOutsideRange(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
                  isBlocked = true;
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
                }
              }

              if (didFocusChange || recomputeDayBlocked) {
                if (isDayBlocked(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
                  isBlocked = true;
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
                }
              }

              if (isBlocked) {
                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
              } else {
                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
              }

              if (didFocusChange || recomputeDayHighlighted) {
                if (isDayHighlighted(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
                }
              }
            });
          });
        }

        if (!this.isTouchDevice && didFocusChange && hoverDate && !this.isBlocked(hoverDate)) {
          const minNightsForHoverDate = getMinNightsForHoverDate(hoverDate);

          if (minNightsForHoverDate > 0 && focusedInput === _constants.END_DATE) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
          }

          if (minNightsForHoverDate > 0 && focusedInput === _constants.START_DATE) {
            modifiers = this.addModifierToRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.addModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
          }
        }

        if (minimumNights > 0 && startDate && focusedInput === _constants.END_DATE) {
          modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
          modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked');
        }

        const today = (0, _moment.default)();

        if (!(0, _isSameDay.default)(this.today, today)) {
          modifiers = this.deleteModifier(modifiers, this.today, 'today');
          modifiers = this.addModifier(modifiers, today, 'today');
          this.today = today;
        }

        if (Object.keys(modifiers).length > 0) {
          this.setState({
            visibleDays: _objectSpread({}, visibleDays, modifiers),
          });
        }

        if (didFocusChange || phrases !== prevPhrases) {
          // set the appropriate CalendarDay phrase based on focusedInput
          const chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
          this.setState({
            phrases: _objectSpread({}, phrases, {
              chooseAvailableDate,
            }),
          });
        }
      }

      return componentWillReceiveProps;
    }()),
  }, {
    key: 'onDayClick',
    value: (function () {
      function onDayClick(day, e) {
        const _this$props2 = this.props;
        const { keepOpenOnDateSelect } = _this$props2;
        const { minimumNights } = _this$props2;
        const { onBlur } = _this$props2;
        const { focusedInput } = _this$props2;
        const { onFocusChange } = _this$props2;
        const { onClose } = _this$props2;
        const { onDatesChange } = _this$props2;
        const { startDateOffset } = _this$props2;
        const { endDateOffset } = _this$props2;
        const { disabled } = _this$props2;
        if (e) e.preventDefault();
        if (this.isBlocked(day)) return;
        const _this$props3 = this.props;
        let { startDate } = _this$props3;
        let { endDate } = _this$props3;

        if (startDateOffset || endDateOffset) {
          startDate = (0, _getSelectedDateOffset.default)(startDateOffset, day);
          endDate = (0, _getSelectedDateOffset.default)(endDateOffset, day);

          if (this.isBlocked(startDate) || this.isBlocked(endDate)) {
            return;
          }

          onDatesChange({
            startDate,
            endDate,
          });

          if (!keepOpenOnDateSelect) {
            onFocusChange(null);
            onClose({
              startDate,
              endDate,
            });
          }
        } else if (focusedInput === _constants.START_DATE) {
          const lastAllowedStartDate = endDate && endDate.clone().subtract(minimumNights, 'days');
          const isStartDateAfterEndDate = (0, _isBeforeDay.default)(lastAllowedStartDate, day) || (0, _isAfterDay.default)(startDate, endDate);
          const isEndDateDisabled = disabled === _constants.END_DATE;

          if (!isEndDateDisabled || !isStartDateAfterEndDate) {
            startDate = day;

            if (isStartDateAfterEndDate) {
              endDate = null;
            }
          }

          onDatesChange({
            startDate,
            endDate,
          });

          if (isEndDateDisabled && !isStartDateAfterEndDate) {
            onFocusChange(null);
            onClose({
              startDate,
              endDate,
            });
          } else if (!isEndDateDisabled) {
            onFocusChange(_constants.END_DATE);
          }
        } else if (focusedInput === _constants.END_DATE) {
          const firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');

          if (!startDate) {
            endDate = day;
            onDatesChange({
              startDate,
              endDate,
            });
            onFocusChange(_constants.START_DATE);
          } else if ((0, _isInclusivelyAfterDay.default)(day, firstAllowedEndDate)) {
            endDate = day;
            onDatesChange({
              startDate,
              endDate,
            });

            if (!keepOpenOnDateSelect) {
              onFocusChange(null);
              onClose({
                startDate,
                endDate,
              });
            }
          } else if (disabled !== _constants.START_DATE) {
            startDate = day;
            endDate = null;
            onDatesChange({
              startDate,
              endDate,
            });
          } else {
            onDatesChange({
              startDate,
              endDate,
            });
          }
        } else {
          onDatesChange({
            startDate,
            endDate,
          });
        }

        onBlur();
      }

      return onDayClick;
    }()),
  }, {
    key: 'onDayMouseEnter',
    value: (function () {
      function onDayMouseEnter(day) {
        /* eslint react/destructuring-assignment: 1 */
        if (this.isTouchDevice) return;
        const _this$props4 = this.props;
        const { startDate } = _this$props4;
        const { endDate } = _this$props4;
        const { focusedInput } = _this$props4;
        const { getMinNightsForHoverDate } = _this$props4;
        const { minimumNights } = _this$props4;
        const { startDateOffset } = _this$props4;
        const { endDateOffset } = _this$props4;
        const _this$state = this.state;
        const { hoverDate } = _this$state;
        const { visibleDays } = _this$state;
        const { dateOffset } = _this$state;
        let nextDateOffset = null;

        if (focusedInput) {
          const hasOffset = startDateOffset || endDateOffset;
          let modifiers = {};

          if (hasOffset) {
            const start = (0, _getSelectedDateOffset.default)(startDateOffset, day);
            const end = (0, _getSelectedDateOffset.default)(endDateOffset, day, rangeDay => rangeDay.add(1, 'day'));
            nextDateOffset = {
              start,
              end,
            }; // eslint-disable-next-line react/destructuring-assignment

            if (dateOffset && dateOffset.start && dateOffset.end) {
              modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
            }

            modifiers = this.addModifierToRange(modifiers, start, end, 'hovered-offset');
          }

          if (!hasOffset) {
            modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
            modifiers = this.addModifier(modifiers, day, 'hovered');

            if (startDate && !endDate && focusedInput === _constants.END_DATE) {
              if ((0, _isAfterDay.default)(hoverDate, startDate)) {
                const endSpan = hoverDate.clone().add(1, 'day');
                modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
              }

              if (!this.isBlocked(day) && (0, _isAfterDay.default)(day, startDate)) {
                const _endSpan2 = day.clone().add(1, 'day');

                modifiers = this.addModifierToRange(modifiers, startDate, _endSpan2, 'hovered-span');
              }
            }

            if (!startDate && endDate && focusedInput === _constants.START_DATE) {
              if ((0, _isBeforeDay.default)(hoverDate, endDate)) {
                modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
              }

              if (!this.isBlocked(day) && (0, _isBeforeDay.default)(day, endDate)) {
                modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
              }
            }

            if (startDate) {
              const startSpan = startDate.clone().add(1, 'day');

              const _endSpan3 = startDate.clone().add(minimumNights + 1, 'days');

              modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan3, 'after-hovered-start');

              if ((0, _isSameDay.default)(day, startDate)) {
                const newStartSpan = startDate.clone().add(1, 'day');
                const newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
                modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
              }
            }

            if (hoverDate && !this.isBlocked(hoverDate)) {
              const minNightsForPrevHoverDate = getMinNightsForHoverDate(hoverDate);

              if (minNightsForPrevHoverDate > 0 && focusedInput === _constants.START_DATE) {
                modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForPrevHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
                modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForPrevHoverDate, 'days'), 'hovered-start-first-possible-end');
              }
            }

            if (!this.isBlocked(day)) {
              const minNightsForHoverDate = getMinNightsForHoverDate(day);

              if (minNightsForHoverDate > 0 && focusedInput === _constants.START_DATE) {
                modifiers = this.addModifierToRange(modifiers, day.clone().add(1, 'days'), day.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
                modifiers = this.addModifier(modifiers, day.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
              }
            }
          }

          this.setState({
            hoverDate: day,
            dateOffset: nextDateOffset,
            visibleDays: _objectSpread({}, visibleDays, modifiers),
          });
        }
      }

      return onDayMouseEnter;
    }()),
  }, {
    key: 'onDayMouseLeave',
    value: (function () {
      function onDayMouseLeave(day) {
        const _this$props5 = this.props;
        const { startDate } = _this$props5;
        const { endDate } = _this$props5;
        const { focusedInput } = _this$props5;
        const { getMinNightsForHoverDate } = _this$props5;
        const { minimumNights } = _this$props5;
        const _this$state2 = this.state;
        const { hoverDate } = _this$state2;
        const { visibleDays } = _this$state2;
        const { dateOffset } = _this$state2;
        if (this.isTouchDevice || !hoverDate) return;
        let modifiers = {};
        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');

        if (dateOffset) {
          modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
        }

        if (startDate && !endDate && (0, _isAfterDay.default)(hoverDate, startDate)) {
          const endSpan = hoverDate.clone().add(1, 'day');
          modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
        }

        if (!startDate && endDate && (0, _isAfterDay.default)(endDate, hoverDate)) {
          modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
        }

        if (startDate && (0, _isSameDay.default)(day, startDate)) {
          const startSpan = startDate.clone().add(1, 'day');

          const _endSpan4 = startDate.clone().add(minimumNights + 1, 'days');

          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan4, 'after-hovered-start');
        }

        if (!this.isBlocked(hoverDate)) {
          const minNightsForHoverDate = getMinNightsForHoverDate(hoverDate);

          if (minNightsForHoverDate > 0 && focusedInput === _constants.START_DATE) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
          }
        }

        this.setState({
          hoverDate: null,
          visibleDays: _objectSpread({}, visibleDays, modifiers),
        });
      }

      return onDayMouseLeave;
    }()),
  }, {
    key: 'onPrevMonthClick',
    value: (function () {
      function onPrevMonthClick() {
        const _this$props6 = this.props;
        const { enableOutsideDays } = _this$props6;
        const { maxDate } = _this$props6;
        const { minDate } = _this$props6;
        const { numberOfMonths } = _this$props6;
        const { onPrevMonthClick } = _this$props6;
        const _this$state3 = this.state;
        const { currentMonth } = _this$state3;
        const { visibleDays } = _this$state3;
        const newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach((month) => {
          newVisibleDays[month] = visibleDays[month];
        });
        const prevMonth = currentMonth.clone().subtract(2, 'months');
        const prevMonthVisibleDays = (0, _getVisibleDays.default)(prevMonth, 1, enableOutsideDays, true);
        const newCurrentMonth = currentMonth.clone().subtract(1, 'month');
        this.setState({
          currentMonth: newCurrentMonth,
          disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
          disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
          visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays)),
        }, () => {
          onPrevMonthClick(newCurrentMonth.clone());
        });
      }

      return onPrevMonthClick;
    }()),
  }, {
    key: 'onNextMonthClick',
    value: (function () {
      function onNextMonthClick() {
        const _this$props7 = this.props;
        const { enableOutsideDays } = _this$props7;
        const { maxDate } = _this$props7;
        const { minDate } = _this$props7;
        const { numberOfMonths } = _this$props7;
        const { onNextMonthClick } = _this$props7;
        const _this$state4 = this.state;
        const { currentMonth } = _this$state4;
        const { visibleDays } = _this$state4;
        const newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(1).forEach((month) => {
          newVisibleDays[month] = visibleDays[month];
        });
        const nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
        const nextMonthVisibleDays = (0, _getVisibleDays.default)(nextMonth, 1, enableOutsideDays, true);
        const newCurrentMonth = currentMonth.clone().add(1, 'month');
        this.setState({
          currentMonth: newCurrentMonth,
          disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
          disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
          visibleDays: _objectSpread({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays)),
        }, () => {
          onNextMonthClick(newCurrentMonth.clone());
        });
      }

      return onNextMonthClick;
    }()),
  }, {
    key: 'onMonthChange',
    value: (function () {
      function onMonthChange(newMonth) {
        const _this$props8 = this.props;
        const { numberOfMonths } = _this$props8;
        const { enableOutsideDays } = _this$props8;
        const { orientation } = _this$props8;
        const withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
        const newVisibleDays = (0, _getVisibleDays.default)(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
        this.setState({
          currentMonth: newMonth.clone(),
          visibleDays: this.getModifiers(newVisibleDays),
        });
      }

      return onMonthChange;
    }()),
  }, {
    key: 'onYearChange',
    value: (function () {
      function onYearChange(newMonth) {
        const _this$props9 = this.props;
        const { numberOfMonths } = _this$props9;
        const { enableOutsideDays } = _this$props9;
        const { orientation } = _this$props9;
        const withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
        const newVisibleDays = (0, _getVisibleDays.default)(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
        this.setState({
          currentMonth: newMonth.clone(),
          visibleDays: this.getModifiers(newVisibleDays),
        });
      }

      return onYearChange;
    }()),
  }, {
    key: 'onMultiplyScrollableMonths',
    value: (function () {
      function onMultiplyScrollableMonths() {
        const _this$props10 = this.props;
        const { numberOfMonths } = _this$props10;
        const { enableOutsideDays } = _this$props10;
        const _this$state5 = this.state;
        const { currentMonth } = _this$state5;
        const { visibleDays } = _this$state5;
        const numberOfVisibleMonths = Object.keys(visibleDays).length;
        const nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
        const newVisibleDays = (0, _getVisibleDays.default)(nextMonth, numberOfMonths, enableOutsideDays, true);
        this.setState({
          visibleDays: _objectSpread({}, visibleDays, this.getModifiers(newVisibleDays)),
        });
      }

      return onMultiplyScrollableMonths;
    }()),
  }, {
    key: 'getFirstFocusableDay',
    value: (function () {
      function getFirstFocusableDay(newMonth) {
        const _this3 = this;

        const _this$props11 = this.props;
        const { startDate } = _this$props11;
        const { endDate } = _this$props11;
        const { focusedInput } = _this$props11;
        const { minimumNights } = _this$props11;
        const { numberOfMonths } = _this$props11;
        let focusedDate = newMonth.clone().startOf('month');

        if (focusedInput === _constants.START_DATE && startDate) {
          focusedDate = startDate.clone();
        } else if (focusedInput === _constants.END_DATE && !endDate && startDate) {
          focusedDate = startDate.clone().add(minimumNights, 'days');
        } else if (focusedInput === _constants.END_DATE && endDate) {
          focusedDate = endDate.clone();
        }

        if (this.isBlocked(focusedDate)) {
          const days = [];
          const lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
          let currentDay = focusedDate.clone();

          while (!(0, _isAfterDay.default)(currentDay, lastVisibleDay)) {
            currentDay = currentDay.clone().add(1, 'day');
            days.push(currentDay);
          }

          const viableDays = days.filter(day => !_this3.isBlocked(day));

          if (viableDays.length > 0) {
            const _viableDays = _slicedToArray(viableDays, 1);

            focusedDate = _viableDays[0];
          }
        }

        return focusedDate;
      }

      return getFirstFocusableDay;
    }()),
  }, {
    key: 'getModifiers',
    value: (function () {
      function getModifiers(visibleDays) {
        const _this4 = this;

        const modifiers = {};
        Object.keys(visibleDays).forEach((month) => {
          modifiers[month] = {};
          visibleDays[month].forEach((day) => {
            modifiers[month][(0, _toISODateString.default)(day)] = _this4.getModifiersForDay(day);
          });
        });
        return modifiers;
      }

      return getModifiers;
    }()),
  }, {
    key: 'getModifiersForDay',
    value: (function () {
      function getModifiersForDay(day) {
        const _this5 = this;

        return new Set(Object.keys(this.modifiers).filter(modifier => _this5.modifiers[modifier](day)));
      }

      return getModifiersForDay;
    }()),
  }, {
    key: 'getStateForNewMonth',
    value: (function () {
      function getStateForNewMonth(nextProps) {
        const _this6 = this;

        const { initialVisibleMonth } = nextProps;
        const { numberOfMonths } = nextProps;
        const { enableOutsideDays } = nextProps;
        const { orientation } = nextProps;
        const { startDate } = nextProps;
        const initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
          return startDate;
        } : function () {
          return _this6.today;
        });
        const currentMonth = initialVisibleMonthThunk();
        const withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
        const visibleDays = this.getModifiers((0, _getVisibleDays.default)(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
        return {
          currentMonth,
          visibleDays,
        };
      }

      return getStateForNewMonth;
    }()),
  }, {
    key: 'shouldDisableMonthNavigation',
    value: (function () {
      function shouldDisableMonthNavigation(date, visibleMonth) {
        if (!date) return false;
        const _this$props12 = this.props;
        const { numberOfMonths } = _this$props12;
        const { enableOutsideDays } = _this$props12;
        return (0, _isDayVisible.default)(date, visibleMonth, numberOfMonths, enableOutsideDays);
      }

      return shouldDisableMonthNavigation;
    }()),
  }, {
    key: 'addModifier',
    value: (function () {
      function addModifier(updatedDays, day, modifier) {
        const _this$props13 = this.props;
        const numberOfVisibleMonths = _this$props13.numberOfMonths;
        const { enableOutsideDays } = _this$props13;
        const { orientation } = _this$props13;
        const _this$state6 = this.state;
        const firstVisibleMonth = _this$state6.currentMonth;
        const { visibleDays } = _this$state6;
        let currentMonth = firstVisibleMonth;
        let numberOfMonths = numberOfVisibleMonths;

        if (orientation === _constants.VERTICAL_SCROLLABLE) {
          numberOfMonths = Object.keys(visibleDays).length;
        } else {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }

        if (!day || !(0, _isDayVisible.default)(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        const iso = (0, _toISODateString.default)(day);

        let updatedDaysAfterAddition = _objectSpread({}, updatedDays);

        if (enableOutsideDays) {
          const monthsToUpdate = Object.keys(visibleDays).filter(monthKey => Object.keys(visibleDays[monthKey]).indexOf(iso) > -1);
          updatedDaysAfterAddition = monthsToUpdate.reduce((days, monthIso) => {
            const month = updatedDays[monthIso] || visibleDays[monthIso];
            const modifiers = new Set(month[iso]);
            modifiers.add(modifier);
            return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterAddition);
        } else {
          const monthIso = (0, _toISOMonthString.default)(day);
          const month = updatedDays[monthIso] || visibleDays[monthIso];
          const modifiers = new Set(month[iso]);
          modifiers.add(modifier);
          updatedDaysAfterAddition = _objectSpread({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterAddition;
      }

      return addModifier;
    }()),
  }, {
    key: 'addModifierToRange',
    value: (function () {
      function addModifierToRange(updatedDays, start, end, modifier) {
        let days = updatedDays;
        let spanStart = start.clone();

        while ((0, _isBeforeDay.default)(spanStart, end)) {
          days = this.addModifier(days, spanStart, modifier);
          spanStart = spanStart.clone().add(1, 'day');
        }

        return days;
      }

      return addModifierToRange;
    }()),
  }, {
    key: 'deleteModifier',
    value: (function () {
      function deleteModifier(updatedDays, day, modifier) {
        const _this$props14 = this.props;
        const numberOfVisibleMonths = _this$props14.numberOfMonths;
        const { enableOutsideDays } = _this$props14;
        const { orientation } = _this$props14;
        const _this$state7 = this.state;
        const firstVisibleMonth = _this$state7.currentMonth;
        const { visibleDays } = _this$state7;
        let currentMonth = firstVisibleMonth;
        let numberOfMonths = numberOfVisibleMonths;

        if (orientation === _constants.VERTICAL_SCROLLABLE) {
          numberOfMonths = Object.keys(visibleDays).length;
        } else {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }

        if (!day || !(0, _isDayVisible.default)(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        const iso = (0, _toISODateString.default)(day);

        let updatedDaysAfterDeletion = _objectSpread({}, updatedDays);

        if (enableOutsideDays) {
          const monthsToUpdate = Object.keys(visibleDays).filter(monthKey => Object.keys(visibleDays[monthKey]).indexOf(iso) > -1);
          updatedDaysAfterDeletion = monthsToUpdate.reduce((days, monthIso) => {
            const month = updatedDays[monthIso] || visibleDays[monthIso];
            const modifiers = new Set(month[iso]);
            modifiers.delete(modifier);
            return _objectSpread({}, days, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterDeletion);
        } else {
          const monthIso = (0, _toISOMonthString.default)(day);
          const month = updatedDays[monthIso] || visibleDays[monthIso];
          const modifiers = new Set(month[iso]);
          modifiers.delete(modifier);
          updatedDaysAfterDeletion = _objectSpread({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, _objectSpread({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterDeletion;
      }

      return deleteModifier;
    }()),
  }, {
    key: 'deleteModifierFromRange',
    value: (function () {
      function deleteModifierFromRange(updatedDays, start, end, modifier) {
        let days = updatedDays;
        let spanStart = start.clone();

        while ((0, _isBeforeDay.default)(spanStart, end)) {
          days = this.deleteModifier(days, spanStart, modifier);
          spanStart = spanStart.clone().add(1, 'day');
        }

        return days;
      }

      return deleteModifierFromRange;
    }()),
  }, {
    key: 'doesNotMeetMinimumNights',
    value: (function () {
      function doesNotMeetMinimumNights(day) {
        const _this$props15 = this.props;
        const { startDate } = _this$props15;
        const { isOutsideRange } = _this$props15;
        const { focusedInput } = _this$props15;
        const { minimumNights } = _this$props15;
        if (focusedInput !== _constants.END_DATE) return false;

        if (startDate) {
          const dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
          return dayDiff < minimumNights && dayDiff >= 0;
        }

        return isOutsideRange((0, _moment.default)(day).subtract(minimumNights, 'days'));
      }

      return doesNotMeetMinimumNights;
    }()),
  }, {
    key: 'doesNotMeetMinNightsForHoveredStartDate',
    value: (function () {
      function doesNotMeetMinNightsForHoveredStartDate(day, hoverDate) {
        const _this$props16 = this.props;
        const { focusedInput } = _this$props16;
        const { getMinNightsForHoverDate } = _this$props16;
        if (focusedInput !== _constants.END_DATE) return false;

        if (hoverDate && !this.isBlocked(hoverDate)) {
          const minNights = getMinNightsForHoverDate(hoverDate);
          const dayDiff = day.diff(hoverDate.clone().startOf('day').hour(12), 'days');
          return dayDiff < minNights && dayDiff >= 0;
        }

        return false;
      }

      return doesNotMeetMinNightsForHoveredStartDate;
    }()),
  }, {
    key: 'isDayAfterHoveredStartDate',
    value: (function () {
      function isDayAfterHoveredStartDate(day) {
        const _this$props17 = this.props;
        const { startDate } = _this$props17;
        const { endDate } = _this$props17;
        const { minimumNights } = _this$props17;

        const _ref2 = this.state || {};
        const { hoverDate } = _ref2;

        return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay.default)(hoverDate, day) && minimumNights > 0 && (0, _isSameDay.default)(hoverDate, startDate);
      }

      return isDayAfterHoveredStartDate;
    }()),
  }, {
    key: 'isEndDate',
    value: (function () {
      function isEndDate(day) {
        const { endDate } = this.props;
        return (0, _isSameDay.default)(day, endDate);
      }

      return isEndDate;
    }()),
  }, {
    key: 'isHovered',
    value: (function () {
      function isHovered(day) {
        const _ref3 = this.state || {};
        const { hoverDate } = _ref3;

        const { focusedInput } = this.props;
        return !!focusedInput && (0, _isSameDay.default)(day, hoverDate);
      }

      return isHovered;
    }()),
  }, {
    key: 'isInHoveredSpan',
    value: (function () {
      function isInHoveredSpan(day) {
        const _this$props18 = this.props;
        const { startDate } = _this$props18;
        const { endDate } = _this$props18;

        const _ref4 = this.state || {};
        const { hoverDate } = _ref4;

        const isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay.default)(hoverDate, day));
        const isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay.default)(hoverDate, day));
        const isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
        return (isForwardRange || isBackwardRange) && isValidDayHovered;
      }

      return isInHoveredSpan;
    }()),
  }, {
    key: 'isInSelectedSpan',
    value: (function () {
      function isInSelectedSpan(day) {
        const _this$props19 = this.props;
        const { startDate } = _this$props19;
        const { endDate } = _this$props19;
        return day.isBetween(startDate, endDate);
      }

      return isInSelectedSpan;
    }()),
  }, {
    key: 'isLastInRange',
    value: (function () {
      function isLastInRange(day) {
        const { endDate } = this.props;
        return this.isInSelectedSpan(day) && (0, _isNextDay.default)(day, endDate);
      }

      return isLastInRange;
    }()),
  }, {
    key: 'isStartDate',
    value: (function () {
      function isStartDate(day) {
        const { startDate } = this.props;
        return (0, _isSameDay.default)(day, startDate);
      }

      return isStartDate;
    }()),
  }, {
    key: 'isBlocked',
    value: (function () {
      function isBlocked(day) {
        const _this$props20 = this.props;
        const { isDayBlocked } = _this$props20;
        const { isOutsideRange } = _this$props20;
        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
      }

      return isBlocked;
    }()),
  }, {
    key: 'isToday',
    value: (function () {
      function isToday(day) {
        return (0, _isSameDay.default)(day, this.today);
      }

      return isToday;
    }()),
  }, {
    key: 'isFirstDayOfWeek',
    value: (function () {
      function isFirstDayOfWeek(day) {
        const { firstDayOfWeek } = this.props;
        return day.day() === (firstDayOfWeek || _moment.default.localeData().firstDayOfWeek());
      }

      return isFirstDayOfWeek;
    }()),
  }, {
    key: 'isLastDayOfWeek',
    value: (function () {
      function isLastDayOfWeek(day) {
        const { firstDayOfWeek } = this.props;
        return day.day() === ((firstDayOfWeek || _moment.default.localeData().firstDayOfWeek()) + 6) % 7;
      }

      return isLastDayOfWeek;
    }()),
  }, {
    key: 'isFirstPossibleEndDateForHoveredStartDate',
    value: (function () {
      function isFirstPossibleEndDateForHoveredStartDate(day, hoverDate) {
        const _this$props21 = this.props;
        const { focusedInput } = _this$props21;
        const { getMinNightsForHoverDate } = _this$props21;
        if (focusedInput !== _constants.END_DATE || !hoverDate || this.isBlocked(hoverDate)) return false;
        const minNights = getMinNightsForHoverDate(hoverDate);
        const firstAvailableEndDate = hoverDate.clone().add(minNights, 'days');
        return (0, _isSameDay.default)(day, firstAvailableEndDate);
      }

      return isFirstPossibleEndDateForHoveredStartDate;
    }()),
  }, {
    key: 'render',
    value: (function () {
      function render() {
        const _this$props22 = this.props;
        const { numberOfMonths } = _this$props22;
        const { orientation } = _this$props22;
        const { monthFormat } = _this$props22;
        const { renderMonthText } = _this$props22;
        const { navPrev } = _this$props22;
        const { navNext } = _this$props22;
        const { noNavButtons } = _this$props22;
        const { onOutsideClick } = _this$props22;
        const { withPortal } = _this$props22;
        const { enableOutsideDays } = _this$props22;
        const { firstDayOfWeek } = _this$props22;
        const { renderKeyboardShortcutsButton } = _this$props22;
        const { hideKeyboardShortcutsPanel } = _this$props22;
        const { daySize } = _this$props22;
        const { focusedInput } = _this$props22;
        const { renderCalendarDay } = _this$props22;
        const { renderDayContents } = _this$props22;
        const { renderCalendarInfo } = _this$props22;
        const { renderMonthElement } = _this$props22;
        const { calendarInfoPosition } = _this$props22;
        const { onBlur } = _this$props22;
        const { onShiftTab } = _this$props22;
        const { onTab } = _this$props22;
        const { isFocused } = _this$props22;
        const { showKeyboardShortcuts } = _this$props22;
        const { isRTL } = _this$props22;
        const { weekDayFormat } = _this$props22;
        const { dayAriaLabelFormat } = _this$props22;
        const { verticalHeight } = _this$props22;
        const { noBorder } = _this$props22;
        const { transitionDuration } = _this$props22;
        const { verticalBorderSpacing } = _this$props22;
        const { horizontalMonthPadding } = _this$props22;
        const _this$state8 = this.state;
        const { currentMonth } = _this$state8;
        const { phrases } = _this$state8;
        const { visibleDays } = _this$state8;
        const { disablePrev } = _this$state8;
        const { disableNext } = _this$state8;
        return _react.default.createElement(_DayPicker.default, {
          orientation,
          enableOutsideDays,
          modifiers: visibleDays,
          numberOfMonths,
          onDayClick: this.onDayClick,
          onDayMouseEnter: this.onDayMouseEnter,
          onDayMouseLeave: this.onDayMouseLeave,
          onPrevMonthClick: this.onPrevMonthClick,
          onNextMonthClick: this.onNextMonthClick,
          onMonthChange: this.onMonthChange,
          onTab,
          onShiftTab,
          onYearChange: this.onYearChange,
          onMultiplyScrollableMonths: this.onMultiplyScrollableMonths,
          monthFormat,
          renderMonthText,
          withPortal,
          hidden: !focusedInput,
          initialVisibleMonth: (function () {
            function initialVisibleMonth() {
              return currentMonth;
            }

            return initialVisibleMonth;
          }()),
          daySize,
          onOutsideClick,
          disablePrev,
          disableNext,
          navPrev,
          navNext,
          noNavButtons,
          renderCalendarDay,
          renderDayContents,
          renderCalendarInfo,
          renderMonthElement,
          renderKeyboardShortcutsButton,
          calendarInfoPosition,
          firstDayOfWeek,
          hideKeyboardShortcutsPanel,
          isFocused,
          getFirstFocusableDay: this.getFirstFocusableDay,
          onBlur,
          showKeyboardShortcuts,
          phrases,
          isRTL,
          weekDayFormat,
          dayAriaLabelFormat,
          verticalHeight,
          verticalBorderSpacing,
          noBorder,
          transitionDuration,
          horizontalMonthPadding,
        });
      }

      return render;
    }()),
  }]);

  return DayPickerRangeController;
}(_react.default.PureComponent || _react.default.Component));

exports.default = DayPickerRangeController;
DayPickerRangeController.propTypes = process.env.NODE_ENV !== 'production' ? propTypes : {};
DayPickerRangeController.defaultProps = defaultProps;
